module.exports = __webpack_public_path__ + "media/images/v2/dollar-sign-876a583b675030f75b479b951cc53a47.svg";